import { createAction, props } from "@ngrx/store";

const prefix = "[Skill Statistics Page Actions]";

export const requestLocations = createAction(`${prefix} Request Locations`);
export const requestLocationsSuccess = createAction(
  `${prefix} Request Locations Success`,
  props<{ locations: string[] }>(),
);
export const requestSkillTypes = createAction(`${prefix} Request Skill Types`);
